<template>
    <div id="cyclic-definition_create">
        <v-form
            ref="form"
            lazy-validation
            >
            <v-checkbox
                v-for="team in teams"
                :key="team.id"
                v-model="checkboxTeams"
                :label="team.name"
                color="red"
                :value="team.id"
                > </v-checkbox>

            <v-btn
                color="primary"
                @click="submit"
                >
                {{ $t('cyclic.continue') }}
            </v-btn>
        </v-form>
    </div>
</template>

<script>
  import http from '@/plugins/http'

export default {
  components: {
  },
  props:["idCyclic","cyclicTeams"],
  data() {
    return {
    teamRules:[v => !!v || "Team is required"],
      basicValid: false,
       teams:[],
       form:{},

        checkboxTeams:  this.cyclicTeams== undefined ?  [] : this.cyclicTeams.map((team)=>parseInt(team.id)),
    }
  },
  computed: {
  },
  methods: {
    loadTeams(){
      this.loading = true
      http.get('teams')
        .then(({ data }) => {
          this.teams=data;
        })
        this.loading = false
    },
    submit(){
      if (this.checkboxTeams.length > 0) {
        let postData={
            "teams_id":this.checkboxTeams
        }
        http.post('cyclic/'+this.idCyclic+'/create-definition-team', postData)
        .then(({ data }) => {
        this.$emit("team-assigned",data)})
      }
    }
  },
created() {
  this.loadTeams()
 }
}
</script>

<style>

</style>
